angular.module('app').config(bookingItemNotificationProviderRouting);

function bookingItemNotificationProviderRouting($routeProvider) {
  //localhost:9000/#/aventurascr/notifications/61f4b61ae7236612c8706faa/d045c46a1dea25fc754ea80547c71958?tp=it&lang=es
  $routeProvider.when('/:subdomain/notifications/:id/:companyApiKey', {
    pageTitle: 'BOOKING_REQUEST',
    template: '<booking-item-notification-provider-page></booking-item-notification-provider-page>',
    authReq: false,
  });
}

bookingItemNotificationProviderRouting.$inject = ['$routeProvider'];
